export default "__VITE_ASSET__d159ed9a__"